import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import moment from '../../../common/moment'
import Component from '../components/calendar.step.jsx'
import actions from '../actions/calendar'
import orchestratorActions from '../actions/orchestrator'
import startActions from '../actions/start'
import addressActions from '../actions/address'
import {push} from 'react-router-redux'
import summaryActions from '../actions/summary'

const MIN_DATE_DIFF_MINUTES = 120
const MIN_RENT_TIME_MINUTES = 60

class Container extends React.Component {

  constructor(props) {
    super(props)
    // props.createRent()
    props.getAddresses()
    props.getUnavailableDates()
    props.getConfigKey()
  }

  continue = () => {
    this.props.setWillReturnItems(true)
    this.props.createRent()
      .then((success) => {
        if (success) this.props.requestNextStep()
      })
  }

  wontReturnItems = () => {
    this.props.setWillReturnItems(false)
    this.props.createReturnTransaction()
      .then((success) => {
        if (success) this.props.requestNextStep()
      })
  }

  goToAddress = () => {
    this.props.requestSpecificStep('address', 'calendar', 'calendar')
  }

  filterStartTimeSlots = () => {

    if (!this.props.dateStartSelected) return []

    const today = moment()
    return this.props.timeslotsStart.filter(t => {
      const date = moment(this.props.dateStartSelected).hour(t.get('Hour')).minute(t.get('Minute'))
      const diff = date.diff(today, 'minutes')
      return diff >= MIN_DATE_DIFF_MINUTES
    })
  }

  filterEndTimeSlots = () => {

    if (!this.props.dateStartSelected || !this.props.dateEndSelected) return []
    if (!this.props.timeslotStartSelected) return []

    const startDate = this.props.dateStartSelected
    const startTimeslot = this.props.timeslotsEnd.find(t => t.get('ID') === this.props.timeslotStartSelected)
    if (!startTimeslot) return []

    startDate.hour(startTimeslot.get('Hour')).minute(startTimeslot.get('Minute'))

    return this.props.timeslotsEnd.filter(t => {
      const date = moment(this.props.dateEndSelected).hour(t.get('Hour')).minute(t.get('Minute'))
      const diff = date.diff(startDate, 'minutes')
      return diff >= MIN_RENT_TIME_MINUTES
    })
  }

  render() {
    return (
      <Component
        {...this.props}
        continue={this.continue}
        goToAddress={this.goToAddress}
        wontReturnItems={this.wontReturnItems}
        timeslotsStart={this.filterStartTimeSlots()}
        timeslotsEnd={this.filterEndTimeSlots()}
      />
    )
  }

  static propTypes = {
    getUnavailableDates: PropTypes.func.isRequired,
    createRent: PropTypes.func.isRequired,
    getAddresses: PropTypes.func.isRequired,
    requestSpecificStep: PropTypes.func.isRequired,
    setWillReturnItems: PropTypes.func.isRequired,
  }
}

const mapStateToProps = (state, props) => {
  const data = state.ui.remove.calendar
  const startData = state.ui.remove.start
  return {
    dateStartSelected: data.get('dateStart'),
    dateEndSelected: data.get('dateEnd'),
    unavailableDates: data.get('unavailableDates').toArray(),
    timeslotStartSelected: data.get('timeslotStart'),
    timeslotEndSelected: data.get('timeslotEnd'),
    timeslotsStart: data.get('timeslotsStart').toArray(),
    timeslotsEnd: data.get('timeslotsEnd').toArray(),
    isCalendarLoading: data.get('isFetchingDates'),
    isTimeSlotLoading: data.get('isFetchingTimeslots'),
    isAddressLoading: data.get('isFetchingAddresses'),
    error: data.get('error'),
    address: startData.getIn(['transaction', 'ID']) ? startData.getIn(['transaction', 'ClientAddress']).Address : '',
    addresses: data.get('addresses').toArray(),
    addressSelected: data.get('address'),
    isContinueLoading: data.get('isModifying') || props.loading,
    isContinueDisabled: data.get('dateStart') === null || data.get('dateEnd') === null,
    isAddMoreItemsDisabled: data.get('isFetchingDates') || data.get('isFetchingAddresses') || data.get('isModifying') || props.loading,
    isWontReturnItemLoading: data.get('isModifying') || props.loading,
    isWontReturnItemDisabled: data.get('dateStart') === null,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addMoreItems: () => {
      dispatch(orchestratorActions.setOpen(false, true))
      dispatch(push('/micatalogo'))
    },
    createRent: () => dispatch(startActions.createSelfRent()),
    createReturnTransaction: () => dispatch(startActions.createReturnTransaction()),
    setWillReturnItems: (bool) => dispatch(startActions.setWillReturnItems(bool)),
    selectDates: (start, end) => dispatch(actions.selectDates(start, end)),
    selectTimeslot: (timeslot, type) => dispatch(actions.selectTimeslot(timeslot, type)),
    getUnavailableDates: () => dispatch(actions.getUnavailableDates()),
    getTimeslots: () => dispatch(actions.getTimeslots()),
    setStep: step => dispatch(orchestratorActions.setStep(step)),
    getAddresses: () => dispatch(addressActions.fetch()),
    selectAddress: (id) => dispatch(addressActions.setSelected(id)),
    getConfigKey: () => dispatch(summaryActions.getConfigKey()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/remove/containers/calendar.js